module.exports = require("dayjs/plugin/arraySupport");